import { createGlobalStyle } from 'styled-components';
import { FONTS, responsive } from './Constants';

export const UtilityStyles = createGlobalStyle`
    * {
        box-sizing  : border-box;
        outline     : none;
    }
    html,
    body{
        margin: 0;
        padding: 0;
        width:100%;
    }
    body{
        background-color    : #F4F7F8;
        font-family         : ${FONTS.PRIMARY};
        line-height         : 1.2;
        min-height          : 100vh;
        position            : relative;
    }
    .full-height{
        height: 100%;
    }
    .full-width {
        width: 100%;
    }
    .fc-daygrid-day-top{
        width:100% !important;
    }
    .fc .fc-daygrid-day-number {
        width:100% !important;
        text-align:center;
    }
    .MuiList-root::-webkit-scrollbar {
        display: none; /* Hide scrollbar in webkit-based browsers */
    }
    .customTimePicker, .MuiList-root {
        -ms-overflow-style: none;  /* Hide scrollbar in IE and Edge */
        scrollbar-width: none;  /* Hide scrollbar in Firefox */
    }
    .flex {
        display: flex;
    }
    .f-v-center{
        align-items: center;
    }
    .f-h-center{
        justify-content: center;
    }

    .text-center{
        text-align: center;
    }

    .visible-md{
        display: none;
        ${responsive.TABLET`display:block`}
    }
    .hidden-md{
        ${responsive.TABLET`display:none`}
    }
    .plain-notification{
        background-color: #fff;
    }

    .elipsis {
        overflow        : hidden;
        text-overflow   : ellipsis;
        white-space     : nowrap;
    }
    
    .no-data-text {
        color       : #707070;
        font-size   : 15px;
        text-align  : center;
        width       : 100%;
    }

    select{
        height:40px;
        border-color: #f5e0b5;
    }

    .animContainer {
  display: flex;

  height: 100%;
}

@keyframes textShine {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}

.textAnim {
  background: linear-gradient(
    to right,
    #002047 20%,
    #001836 30%,
    #b3b3b3 70%,
    #00377a 80%
  );
  text-wrap: nowrap;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-fill-color: transparent;
  background-size: 500% auto;
  animation: textShine 5s ease-in-out infinite alternate;
}

@keyframes iconShimmer {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

/* width */
.sidebarMain::-webkit-scrollbar {
  width: 5px;
}

/* Track */
.sidebarMain::-webkit-scrollbar-track {
  background: #f5e0b5; 
  border:1px solid #f5e0b5;
}
 
/* Handle */
.sidebarMain::-webkit-scrollbar-thumb {
  background: #002047; 
  border:1px solid #f5e0b5;
}

/* Handle on hover */
.sidebarMain::-webkit-scrollbar-thumb:hover {
  background: #002047; 
}

.css-z3c6am-MuiFormControl-root-MuiTextField-root {
  width:100% !important;
}

.fc-direction-ltr .fc-daygrid-more-link {
    float: right;
    text-decoration: underline;
    color: dodgerblue;
}

.css-1whevnm-MuiFormLabel-root-MuiInputLabel-root{
  top:-17% !important;
}

.css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root {
    top: -4px !important;
}
`;
